import { ClampingTextCSSUsage } from './ClampingTextCSSUsage'
import { ClampingTextUsage } from './ClampingTextUsage'

export const CLAMPING_TEXT_MENU = [
  'ClampingText',
  [
    ['ClampingText', ClampingTextUsage],
    ['ClampingTextCSS', ClampingTextCSSUsage],
  ],
]
